/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation/Add/Content/Details/Title",
  onChange
  
}) {
let newRelationPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'person.title',
})
let newRelationPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 maxWidth={280}
 data="new_relation.person.title"
 value={newRelationPersonTitleValueData}
 onChange={newRelationPersonTitleChangeData}
/>
{children}
</React.Fragment>)
}